import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectSelectedProductsImmutable } from 'selectors/productsCartSelectors';
import { calculateAllTotalQuantitiesByProductCode } from 'utils/productsCart/calculateStock';

/**
 * useTotalQuantitiesByProductCode hook.
 * Calculates total quantity selected for each product code across all passengers in a specific segment.
 * Used to determine available stock considering all passengers' selections.
 *
 * @param {string} segment - Segment: 'outgoing' or 'incoming'
 * @returns {Object} Object keyed by product code with total quantity selected
 *
 * @example
 * const totalQuantities = useTotalQuantitiesByProductCode('outgoing');
 * // Returns: { 'BEB001': 5, 'SNK002': 3 }
 * // This means BEB001 has 5 total units selected across all passengers
 */
export const useTotalQuantitiesByProductCode = (segment = 'outgoing') => {
  const allSelectedProducts = useSelector(selectSelectedProductsImmutable);

  return useMemo(() => {
    return calculateAllTotalQuantitiesByProductCode(allSelectedProducts, segment);
  }, [allSelectedProducts, segment]);
};

export default useTotalQuantitiesByProductCode;
